import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/authorizationInfo', request)
}

export {get}
